<template>
    <chart :options="chartOptions"></chart>
</template>

<script setup lang="ts">
import { Chart } from "highcharts-vue";

const props = defineProps({
    data: { type: Array<number>, default: [] }
});

const emit = defineEmits({
    'yearSelected': null
});

const chartOptions = {
    chart: {
        type: 'column',
        spacingLeft: 0,
        marginRight: 0,
        animation: {
            duration: 1100
        }
    },
    title: {
        text: undefined
    },
    xAxis: {
        title: {
            text: 'Retirement Year'
        },
        crosshair: true,
        accessibility: {
            description: 'Retirement Year'
        }
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        },
    },
    tooltip: {
        enabled: false
    },
    plotOptions: {
        column: {
            pointPadding: 0.2,
            borderWidth: 0,
        },
        series: {
            cursor: 'pointer',
            events: {
                click: function(event) {
                    emit('yearSelected', event.point.category - 1);
                }
            },
            color: 'rgb(40, 121, 188)'
        }
    },
    series: [
        {
            name: '',
            pointStart: 1,
            data: props.data,
            showInLegend: false,
            selected: 4
        }
    ]
};

</script>
